<template>
  <div>
    <template v-if="notification.data.record_id">
      <p class="notification_label">You were mentioned in a lead</p>
      <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
    </template>
    <template v-else-if="notification.data.contact_id">
      <p class="notification_label">You were mentioned on a contact</p>
      <button-link @click="goToContact">{{ notification.data.contact_name }}</button-link>
    </template>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";

export default {
  name: "MentionNotification",
  props: {
    notification: Object
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.replace({query: {lead: this.notification.data.record_id}});
    },
    goToContact() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.replace({query: {contact: this.notification.data.contact_id}})
    }
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
